import React from 'react';
import { RiFile2Fill } from 'react-icons/ri';

export const FileBadge = ({ text, iconColor, onClick, disabled }: FileBadgeProps) => {
  const handleClick = () => {
    if (disabled) return;
    onClick?.();
  };

  return (
    <div className={'flex flex-row items-center gap-2' + ((onClick) ? ' hover:cursor-pointer' : '')}
         onClick={() => handleClick()}>
      <RiFile2Fill size={20} color={(disabled) ? '#DDD' : iconColor} />
      <span>{text}</span>
    </div>
  );
};

interface FileBadgeProps {
  text: string,
  iconColor: string
  disabled?: boolean;
  onClick?: () => void;
}